import React from "react";
import { Box } from "@mui/material";

import FormBuilder from "../../../Common/FormBuilder/FormBuilder";
import AppraisalTable from "./AppraisalTable";

function AppraisalContent({ segment, onFormFieldChange }) {
    const canUpdate = segment?.canUpdate ?? false;
    return (
        <>
            <Box className="card-content">
                <AppraisalTable items={segment?.items ?? []} />
            </Box>
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
        </>
    );
}

export default AppraisalContent;
